import { GetCulpritTimeSetQueryParamsType } from '@/common/queries/getCulpritTimeSet/getCulpritTimeSetQuery.type';
import { getCulpritTimeSetFunction } from '@/common/queries/getCulpritTimeSet/getCulpritTimeSetQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getCulpritTimeSetQueryOptions = (
  params: GetCulpritTimeSetQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['getCulpritTimeSetQueryOptions', params],
    queryFn: () => getCulpritTimeSetFunction(params),
  });
};
